import { CollegeBanner } from "apollo/model/college"
import LineBreak from "components/common/LineBreak"
import { navRoutes } from "page_routes"
import { ReactNode } from "react"
export type IeltsBannerDataInterface = CollegeBanner & {
  imgSrc?: ImgSrc
}

interface ImgSrc {
  web: string
  mob: string
}

export interface FeatureList {
  title: string
  img: string
}
export interface RewardsList {
  id: number
  label: string
  title: string
  img: string
  data: string
  url: string
}

export const ieltsBannerData: IeltsBannerDataInterface = {
  title: "IELTS Plus Features",
  location: "Live Classes",
  established: "Mock Tests for all sections",
  season: "Personalised speaking evaluations",
  status: "Free Study Material",
  iconImages: {
    location: `${process.env.CDN_URL}/assets/images/ielts/banner/icons/liveClass.svg`,
    established: `${process.env.CDN_URL}/assets/images/ielts/banner/icons/mocks.svg`,
    season: `${process.env.CDN_URL}/assets/images/ielts/banner/icons/speaking.svg`,
    status: `${process.env.CDN_URL}/assets/images/ielts/banner/icons/public.svg`,
  },
  imgSrc: {
    web: `${process.env.CDN_URL}/assets/images/ielts/banner/BannerImage-web.jpg`,
    mob: `${process.env.CDN_URL}/assets/images/ielts/banner/mobile-banner.png`,
  },
}

export const ieltsFeatureList: Array<FeatureList> = [
  {
    title: "Daily Live classes",
    img: `${process.env.CDN_URL}/assets/images/ielts/banner/feature/video.svg`,
  },
  {
    title: "5 Mock Tests + Study Material",
    img: `${process.env.CDN_URL}/assets/images/ielts/banner/feature/book.svg`,
  },
  {
    title: "3 Speaking & Writing Evalution",
    img: `${process.env.CDN_URL}/assets/images/ielts/banner/feature/writing.svg`,
  },
]

export const rewardFeatureList: Array<string> = [
  "Daily LIVE Classes",
  "1 Speaking Slot",
  "2 Mock Tests",
  "Study Materials",
]

export const rewardCardFeatureList: Array<string> = [
  "Daily Live Classes",
  "1 free speaking evaluation",
  "Study materials",
  "2 Mock Tests",
]

export const rewardsListByDay: Array<RewardsList> = [
  {
    id: 1,
    label: "DAY 1",
    img: `${process.env.CDN_URL}/assets/icons/rewardicons/callRecording.svg`,
    data: "Unlimited, lifetime access to class recordings",
    title: "Class recordings",
    url: navRoutes.IELTS_CLASS_RECORDINGS,
  },
  {
    id: 2,
    label: "DAY 2",
    img: `${process.env.CDN_URL}/assets/icons/rewardicons/accesstospeakingrooms.svg`,
    data: "Download IELTS Prep App and start hosting your room speaking rooms for unlimited practice!",
    title: "Host access to speaking rooms",
    url: navRoutes.IELTS_REWARDS,
  },
  {
    id: 3,
    label: "DAY 3",
    img: `${process.env.CDN_URL}/assets/icons/rewardicons/fasttrack.svg`,
    data: "50 hours of crisp videos covering all major IELTS topics",
    title: "Fast Track course",
    url: navRoutes.IELTS_STUDENT_DASHBOARD,
  },
  {
    id: 4,
    label: "DAY 4",
    img: `${process.env.CDN_URL}/assets/icons/rewardicons/speakingclubslots.svg`,
    data: "2 chances to practice and get feedback from a professional IELTS evaluator",
    title: "2 speaking club slots",
    url: navRoutes.IELTS_SPEAKING_CLUB,
  },
  {
    id: 5,
    label: "DAY 5",
    img: `${process.env.CDN_URL}/assets/icons/rewardicons/doughtclass.svg`,
    data: "Attend extra classes conducted by your favourite teachers and clear all your doubts",
    title: "Extra doubt class",
    url: navRoutes.IELTS_REWARDS,
  },
  {
    id: 6,
    label: "DAY 6",
    img: `${process.env.CDN_URL}/assets/icons/rewardicons/speakingclubslots.svg`,
    data: "2 mock tests including a full length writing evaluation",
    title: "2 Mock tests",
    url: navRoutes.IELTS_MOCK_TEST,
  },
  {
    id: 7,
    label: "DAY 7",
    img: `${process.env.CDN_URL}/assets/icons/rewardicons/chatwithteacher.svg`,
    data: "Connect with Teacher on Telegram and clear your doubts!",
    title: "Chat with Educator",
    url: navRoutes.IELTS_REWARDS,
  },
  {
    id: 8,
    label: "DAY 8",
    img: `${process.env.CDN_URL}/assets/icons/rewardicons/discounticon.svg`,
    data: "Unlock a discount on IELTS Premium - our flagship course with just 20 students in a batch, extra mock tests, and personal evaluations for speaking and writing!",
    title: "10% off on IELTS Premium",
    url: navRoutes.IELTS_ALL_BATCHES,
  },
  {
    id: 9,
    label: "DAY 9",
    img: `${process.env.CDN_URL}/assets/icons/rewardicons/speakingclubslots.svg`,
    data: "1 mock tests including a full length writing evaluation",
    title: "1 Mock test",
    url: navRoutes.IELTS_MOCK_TEST,
  },
  {
    id: 10,
    label: "DAY 10",
    img: `${process.env.CDN_URL}/assets/icons/rewardicons/speakingclubslots.svg`,
    data: "2 chances to practice and get feedback from a professional IELTS evaluator",
    title: "5 speaking club slots",
    url: navRoutes.IELTS_SPEAKING_CLUB,
  },
]

export const rewardsMapping: { [keys: string]: { img: string; url: string } } =
  {
    SPEAKING_ROOM_HOST: {
      img: `${process.env.CDN_URL}/assets/icons/rewardicons/accesstospeakingrooms.svg`,
      url: navRoutes.IELTS_REWARDS,
    },
    RECORDING: {
      img: `${process.env.CDN_URL}/assets/icons/rewardicons/callRecording.svg`,
      url: navRoutes.IELTS_CLASS_RECORDINGS,
    },
    FAST_TRACK_COURSE: {
      img: `${process.env.CDN_URL}/assets/icons/rewardicons/fasttrack.svg`,
      url: navRoutes.FAST_TRACK,
    },
    SPEAKING_CLUB_SLOT: {
      img: `${process.env.CDN_URL}/assets/icons/rewardicons/accesstospeakingrooms.svg`,
      url: navRoutes.IELTS_REWARDS,
    },
    EXTRA_DOUBT_CLASS: {
      img: `${process.env.CDN_URL}/assets/icons/rewardicons/doughtclass.svg`,
      url: navRoutes.IELTS_REWARDS,
    },
    MOCK_TEST: {
      img: `${process.env.CDN_URL}/assets/icons/rewardicons/speakingclubslots.svg`,
      url: navRoutes.IELTS_MOCK_TEST,
    },
    TEACHER_CHAT: {
      img: `${process.env.CDN_URL}/assets/icons/rewardicons/chatwithteacher.svg`,
      url: navRoutes.IELTS_REWARDS,
    },
    DISCOUNT: {
      img: `${process.env.CDN_URL}/assets/icons/rewardicons/discounticon.svg`,
      url: navRoutes.IELTS_ALL_BATCHES,
    },
  }

export const rewardPurchase = {
  FREE_COURSE_PURCHASE: "FREE_COURSE_PURCHASE",
  DEFAULT_PURCHASE: "DEFAULT_PURCHASE",
}

export const rewardStatus = {
  LOCKED: "LOCKED",
  ACTIVE: "ACTIVE",
  UNLOCKED: "UNLOCKED",
}

export const demoFormReward: Array<{
  id: number
  title: string | ReactNode
  image: string
}> = [
  {
    id: 1,
    title: (
      <span>
        Learn IELTS exam <LineBreak device="desktop" /> and structure
      </span>
    ),
    image: `${process.env.CDN_URL}/assets/images/ielts/ielts-demo/offers/lecture.svg`,
  },
  {
    id: 2,
    title: (
      <span>
        Get your Band <LineBreak device="desktop" /> predicted
      </span>
    ),
    image: `${process.env.CDN_URL}/assets/images/ielts/ielts-demo/offers/class.svg`,
  },
  {
    id: 3,
    title: (
      <span>
        Tips and tricks to <LineBreak device="desktop" /> improve your band
      </span>
    ),
    image: `${process.env.CDN_URL}/assets/images/ielts/ielts-demo/offers/group.svg`,
  },
]

export const demoFormRewardMweb: Array<{
  id: number
  title: string | ReactNode
  image: string
}> = [
  {
    id: 1,
    title: "Live interaction with IELTS mentor",
    image: `${process.env.CDN_URL}/assets/images/live_icon_youtube.svg`,
  },
  ...demoFormReward,
]

export const liyValueProps: string[] = [
  "Unlocking 1-on-1 Speaking Evaluations",
  "Finding Writing Feedback",
  "Adding recorded lecture videos",
  "Looking for Mock Tests to practice",
]
